"use client";

import { useSyncExternalStore } from "react";
import {
  browserReachabilityEnvironment,
  createReachabilityStore,
  type ReachabilityStore
} from "./api-reachability";

let browserStore: ReachabilityStore | null = null;

function getBrowserStore() {
  browserStore ??= createReachabilityStore(browserReachabilityEnvironment());
  return browserStore;
}

export function useOnlineStatus() {
  return useSyncExternalStore(
    (onStoreChange) => getBrowserStore().subscribe(onStoreChange),
    () => getBrowserStore().getSnapshot(),
    () => true
  );
}
